import axios, { AxiosError, AxiosInstance, CreateAxiosDefaults } from 'axios'


import { setCookie,  } from './setCookie'
import { deleteCookie,  } from './deleteCookie'


import useToken, { getClientInfo } from './useToken'
import { Device } from '@capacitor/device'
import { baseURL, tokenKey } from '../../global'

let refreshingFunc: any = undefined

async function renewToken(authToken: string, refreshToken: string) {
    const info = await Device.getId()
    const deviceId = info.identifier
    const response = await axios.post(
        `${baseURL}/Auth/RefreshToken`,
        {
            loginIp: '0.0.0.0',//res?.data?.IPv4 ?? '',
            refreshToken,
        },
        { headers: { Authorization: `Bearer ${authToken}`, deviceId } },
    )
    if (response?.data!) {
        const res = response?.data!
        if (res.succeeded) {
            const authToken = res?.data?.authToken! ?? ''
            const refreshToken = res?.data?.refreshToken! ?? ''
            return [authToken, refreshToken]
        }
    }
    return [authToken, refreshToken]
}

function isUnauthorizedError(error:any) {
    const {
        response: { status, statusText },
    } = error
    return status === 401
}
//@ts-ignore
async function refreshingFunction(token: string, refreshToken: string, error: AxiosError) {
    const originalConfig = error.config!

    // if we don't have token in local storage or error is not 401 just return error and break req.
    if (!token || !isUnauthorizedError(error)) {
        return Promise.reject(error)
    }
    try {
        // `refreshingFunc` is global, e.g. 2 expired requests will get the same function pointer and await same function.
        if (!refreshingFunc)
            refreshingFunc = renewToken(token, refreshToken!)

        const [newToken, newRefreshToken] = await refreshingFunc
        setCookie(tokenKey, newToken)
        setCookie('refreshToken', newRefreshToken)

        token = newToken
        refreshToken = newRefreshToken
        originalConfig.headers.Authorization = `Bearer ${newToken}`

        // retry original request
        try {
            return await axios.request(originalConfig)
        } catch (innerError) {
            // if original req failed with 401 again - it means server returned not valid token for refresh request
            if (isUnauthorizedError(innerError)) {
                throw innerError
            }
        }

    } catch (err) {
        deleteCookie(tokenKey)
        deleteCookie('refreshToken')
        deleteCookie('level')

        window.location.reload()

    } finally {
        refreshingFunc = undefined
    }
}
export const useAxiosInstance = (omitToken?: boolean, provisionalToken?: string, options?: CreateAxiosDefaults) => {
    
    const { token, refreshToken, locationId } = useToken()

    const axiosInstance = axios.create({
        baseURL,
        ...options,
    })

    // Request Interceptor
    axiosInstance.interceptors.request.use(async (req) => {
        const info = await Device.getId()
        const clientInfo = await getClientInfo()
        const request = req

        request.headers.deviceId = info.identifier
        request.headers.ClientIp = clientInfo?.ip
        // request.params={
        //     loginIp:clientInfo?.ip!
        // }
        if (!omitToken) {
                request.headers.Authorization = `Bearer ${provisionalToken ?? token}`
            }
            if (locationId) {
                request.headers.LocationId = locationId
            }

        return request
    })

    // Response Interceptor
    axiosInstance.interceptors.response.use(
        (res) => res,
        async (error) => {
            if (token && !omitToken && !provisionalToken) {
                    return refreshingFunction(token, refreshToken!, error)
                }

            return Promise.reject(error)
        }
    )

   
    return { axiosInstance }
}
